module.exports = __webpack_public_path__ + "img/8.df7de1c1.png";